var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@mui/material';
import { cn } from 'hx-util';
export function ResultsPageModalToggle(_a) {
    var className = _a.className, toggleModal = _a.toggleModal, text = _a.text;
    return (_jsx(Link, __assign({ className: cn("mx-auto", className), component: "button", onClick: function () { return toggleModal(); }, variant: 'body-1' }, { children: text })));
}
;
